import React from "react";
import { CustomModal } from "../../../../components";
import Context from "../../../../context";
import { ICreateAndUpdateDriver } from "../../../../types/driver.interface";

import Component from "./Component";

import "./index.sass";

const Update = ({
  role,
}: {
  role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY";
}) => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, updateFunction, selectedDriver } =
    React.useContext(Context.DriverScreen);
  const [step, setStep] = React.useState<number>(1);
  const [formData, setFormData] = React.useState<ICreateAndUpdateDriver>({
    ...selectedDriver,
  });

  function submitDriverInformation(event: ICreateAndUpdateDriver) {
    setFormData({ ...formData, ...event });
    setStep(2);
  }


  function onBackCarInformation(event: ICreateAndUpdateDriver) {
    setFormData({ ...formData, ...event });
    setStep(1);
  }

  function submitCarInformation(event: ICreateAndUpdateDriver) {
    updateFunction!({ ...formData, ...event,nationalCode:formData?.nationalCode });
    setStep(1);
  }

  React.useEffect(() => {
    setFormData({ ...selectedDriver });
  }, [selectedDriver]);

  function RenderCreateDriver() {
    switch (step) {
      case 1:
        switch (role) {
          case "ADMIN":
            return (
              <Component.AdministratorDriverInformation
                defaultValues={formData}
                onSubmit={submitDriverInformation}
              />
            );
          case "SUPER_AGENT_SCHOOL":
            return (
              <Component.SuperAgentDriverInformation
                defaultValues={formData}
                onSubmit={submitDriverInformation}
              />
            );
          case "COMPANY":
            return (
              <Component.CompanyDriverInformation
                defaultValues={formData}
                onSubmit={submitDriverInformation}
              />
            );
          default:
            return null;
        }
      case 2:
        return (
          <Component.CarInformation
            defaultValues={formData}
            onSubmit={submitCarInformation}
            onBack={onBackCarInformation}
          />
        );
      default:
        return <></>;
    }
  }

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="driver-update-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "UPDATE"}
      >
        <RenderCreateDriver />
      </CustomModal>
    </section>
  );
};

export default Update;
